import React, { useState, useEffect } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const Weights = () => {
  const [searchParams] = useSearchParams();
  const user_id = searchParams.get('user_id');
  const { fetchWithAuth } = useAuth();
  
  const [weights, setWeights] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const limit = 20;

  useEffect(() => {
    fetchWeights();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, user_id]);

  const fetchWeights = async () => {
    setLoading(true);
    try {
      const url = user_id 
        ? `/api/weights?page=${page}&limit=${limit}&user_id=${user_id}`
        : `/api/weights?page=${page}&limit=${limit}`;
      
      const response = await fetchWithAuth(url);
      if (!response.ok) throw new Error('Failed to fetch weight records');
      const data = await response.json();
      setWeights(data.data);
      setTotal(data.total);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const totalPages = Math.ceil(total / limit);

  if (loading && weights.length === 0) return <div className="loading">Loading...</div>;
  if (error) return <div className="error">Error: {error}</div>;

  return (
    <div>
      <h1 style={{ fontSize: '32px', fontWeight: '700', marginBottom: '24px' }}>
        Weight Records {user_id && `- User ${user_id}`}
      </h1>

      {user_id && (
        <div style={{ marginBottom: '16px' }}>
          <Link to="/weights" className="link">← View All Weight Records</Link>
        </div>
      )}

      <div className="card">
        <div style={{ marginBottom: '16px', color: '#666' }}>
          {total} total records
        </div>

        <div className="table-container">
          <table>
            <thead>
              <tr>
                <th>ID</th>
                <th>User</th>
                <th>Weight (kg)</th>
                <th>Weight (lbs)</th>
                <th>Date</th>
                <th>Created</th>
              </tr>
            </thead>
            <tbody>
              {weights.map((weight) => (
                <tr key={weight.id}>
                  <td>{weight.id}</td>
                  <td>
                    <Link to={`/users/${weight.user_id}`} className="link">
                      {weight.user_name || `User ${weight.user_id}`}
                    </Link>
                  </td>
                  <td>
                    <strong>{weight.weight_kg ? `${weight.weight_kg} kg` : 'N/A'}</strong>
                  </td>
                  <td>
                    {weight.weight_kg ? `${(weight.weight_kg * 2.20462).toFixed(1)} lbs` : 'N/A'}
                  </td>
                  <td>{weight.dateMs ? new Date(parseInt(weight.dateMs)).toLocaleDateString() : 'N/A'}</td>
                  <td>{formatDate(weight.created_at)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="pagination">
          <button
            className="btn btn-secondary"
            onClick={() => setPage(page - 1)}
            disabled={page === 1}
          >
            Previous
          </button>
          <span className="page-info">
            Page {page} of {totalPages}
          </span>
          <button
            className="btn btn-secondary"
            onClick={() => setPage(page + 1)}
            disabled={page >= totalPages}
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default Weights;


